import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'antd';

function ErrorModal(props) {
    const [show, setShow] = useState(false)

    useEffect(() => {
        setShow(props.show)
        console.log('show', show)
    }, [])

    const handleClose = () => {
        props.closeModal()
        setShow(false)
    }

    return(
        <>
            <Modal
                title={props.title}
                centered
                visible={show}
                onCancel={handleClose}
                footer={[
                    <Button key="submit" type="primary" onClick={handleClose}>OK</Button>
                ]}

            >
                <p class="survey-modal-content">{props.message}</p>
            </Modal>
        </>
    )
}

export default ErrorModal